<template>
    <ContainerWithMenu>
        <div class="page-content">
            <h1 class="h2">{{$t('views.content.title')}}</h1>
            <p class="margin-bottom-40">--</p>
            <div class="row">
                <div class="col-xs-12 col-sm-3 col-md-4">
                    <router-link to="/content/videos">
                      <div href="" class="panel panel-default">
                          <div class="panel-body">
                              <i class="las la-video margin-bottom-5" style="font-size:40px;"></i>
                              <h4>{{$t('views.videos.title')}}</h4>
                              {{$t('views.content.video_message')}}
                          </div>
                      </div>
                    </router-link>
                </div>
            </div>
        </div>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import i18n from "../i18n";

    export default {
        title: i18n.t('views.content.title'),
        name: "Content",
        components: { ContainerWithMenu }

    };
</script>